export class RacerDatabase {
  private static readonly RACER_NAMES = {
    Argentina: {
      en: "Argentina",
      fr: "Argentine",
    },
    Australia: {
      en: "Australia",
      fr: "Australie",
    },
    Brazil: {
      en: "Brazil",
      fr: "Brésil",
    },
    Canada: {
      en: "Canada",
      fr: "Canada",
    },
    Chile: {
      en: "Chile",
      fr: "Chili",
    },
    Denmark: {
      en: "Denmark",
      fr: "Danemark",
    },
    France: {
      en: "France",
      fr: "France",
    },
    Germany: {
      en: "Germany",
      fr: "Allemagne",
    },
    "Great Britain": {
      en: "Great Britain",
      fr: "Grande-Bretagne",
    },
    "Hong Kong": {
      en: "Hong Kong",
      fr: "Hong Kong",
    },
    India: {
      en: "India",
      fr: "Inde",
    },
    Ireland: {
      en: "Ireland",
      fr: "Irlande",
    },
    Italy: {
      en: "Italy",
      fr: "Italie",
    },
    Japan: {
      en: "Japan",
      fr: "Japon",
    },
    "New Zealand": {
      en: "New Zealand",
      fr: "Nouvelle-Zélande",
    },
    Peru: {
      en: "Peru",
      fr: "Pérou",
    },
    Singapore: {
      en: "Singapore",
      fr: "Singapour",
    },
    "South Africa": {
      en: "South Africa",
      fr: "Afrique du Sud",
    },
    "South Korea": {
      en: "South Korea",
      fr: "Corée du Sud",
    },
    Spain: {
      en: "Spain",
      fr: "Espagne",
    },
    Sweden: {
      en: "Sweden",
      fr: "Suède",
    },
    Turkey: {
      en: "Turkey",
      fr: "Turquie",
    },
    "United Arab Emirates": {
      en: "UAE",
      fr: "Émirats Arabes Unis",
    },
    "United States": {
      en: "United States",
      fr: "États-Unis",
    },
    Uruguay: {
      en: "Uruguay",
      fr: "Uruguay",
    },
  };

  public static getRacerName(key: string): string {
    const locale = window?.localStorage?.getItem("vs_locale") ?? "en";
    return RacerDatabase.RACER_NAMES[key]?.[locale] ?? key;
  }
}
